const email = (value: string, previousValue: string): string =>
  value === '' ||
  /^[^()±!£$%^&*§¡€#¢§¶•ªº«\\/<>?:;|=,¿'`´¨ç{}/[ ]{1,200}$/.test(value.toLowerCase())
    ? value.toLowerCase()
    : previousValue;

const names = (value: string, previousValue: string): string =>
  !value ||
  value === '' ||
  (/^[^±!@£$%^&*_+§¡€#¢§¶•ªº«\\/<>?:;|=.,0123456789-]{1,200}$/.test(value) &&
    value.trim() !== '' &&
    value.length - value.trim().length < 2)
    ? value
    : previousValue;

const numeric = (value: string, previousValue: string): string =>
  value === '' || /^[0-9]$/.test(value) ? value : previousValue;

const postalCode = (value: string, previousValue: string): string =>
  value === '' || /^[0-9]{1,5}$/.test(value) ? value : previousValue;

const postCodeSoft = (value: string, previousValue: string): string =>
  !value ||
  value === '' ||
  (/^[^±!@£$%^&*_+§¡€#¢§¶•ªº«\\/<>?:;|=.,()"'~]{1,10}$/.test(value) &&
    value.trim() !== '' &&
    value.length - value.trim().length < 2)
    ? value.toUpperCase()
    : previousValue;

const normalizers = {
  email,
  names,
  numeric,
  postalCode,
  postCodeSoft,
};

export default normalizers;
